import Page from '../base/Page';

export default class FAQPage extends Page {
    constructor() {
        super('.FAQPage');
    }

    init() {
        this.topLink();
    }

    topLink() {
        $('.faqTopLink').click(function(){
            $('html,body').animate({ scrollTop: 0 }, 'slow');
            return false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/FAQPage.js